import { useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import NavMenu from '../Navigation/NavMenu';
import { useAuth } from '@/providers/AuthProvider';
import config from '@/config';

export default function DashboardLayout() {
  const { pathname } = useLocation();
  const { groups } = useAuth();

  const { pathSegments } = useMemo(() => {
    const pathSegments = pathname.split('/').filter(Boolean);

    return {
      pathSegments
    };
  }, [pathname]);

  const isAdmin = groups.find((group) => group.includes('admin')) !== undefined;
  const isSuperAdmin = groups.includes(config.admin.superAdminGroup);

  return (
    <div className="flex bg-secondary-clementine-100 h-screen">
      <NavMenu pathSegments={pathSegments} isAdmin={isAdmin} isSuperAdmin={isSuperAdmin} />
      <div className="elevated rounded-l-lg bg-white w-full bg-cover h-full flex flex-col @container">
        <Outlet />
      </div>
    </div>
  );
}
